module.exports = __webpack_public_path__ + "static/media/travicar_TT11.66c110b8.png";